import OnboardingMessage from "./onboarding-message";
export default OnboardingMessage;
